module.exports = __webpack_public_path__ + "img/1556030134.da57b468.jpg";